import type {AxiosPromise} from 'axios'
import axios from '@/plugin/axios'
import api from '@/api'

export const location = {
  fetchLocationHistory,
  fetchLastKnownLocation
}

function fetchLocationHistory(_sn: string, _params: Record<string, any>): AxiosPromise {
  return axios.get(api.endpoints.DPMM_API.LOCATION_DATA.replace('{serial}', _sn), {params: _params})
}

function fetchLastKnownLocation(_sn: string): Promise<any> {
  let endDateTime = new Date()
  let searchRangeDays = 6
  const calculatedStart = new Date(endDateTime.getTime())
  calculatedStart.setDate(calculatedStart.getDate() - searchRangeDays)

  return new Promise((resolve, reject) => {
    (async function () {
      let finished = false
      while (!finished) {
        const r = await axios.get(api.endpoints.DPMM_API.LOCATION_DATA.replace('{serial}', _sn), {
          params: {limit: 2000, start_date_time: calculatedStart, end_date_time: endDateTime}
        })
        if (r.data?.items && r.data.items.length > 0) {
          if (r.data.items.length <= 1999 || searchRangeDays === 1) {
            resolve(
              r.data.items
                .sort((a: any, b: any) => new Date(a.startTs).getTime() - new Date(b.startTs).getTime())
                .pop()
            )
            finished = true
          } else {
            searchRangeDays = searchRangeDays === 3 ? 1 : searchRangeDays / 2
          }
        } else {
          if (calculatedStart.getTime() <= 0) {
            resolve(false)
            finished = true
          }
          endDateTime = new Date(calculatedStart.getTime())
          searchRangeDays *= 2
        }
        calculatedStart.setDate(calculatedStart.getDate() - searchRangeDays)
      }
    })().catch(e => {
      reject(e)
    })
  })
}
